"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Close = void 0;
var React = __importStar(require("react"));
function Close(props) {
    return (React.createElement("svg", __assign({}, props, { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 30, height: 30, viewBox: "0 0 30 30" }),
        React.createElement("defs", null,
            React.createElement("linearGradient", { id: "linear-gradient", x1: 0.5, x2: 0.5, y2: 1, gradientUnits: "objectBoundingBox" },
                React.createElement("stop", { offset: 0, stopColor: "#2994ff" }),
                React.createElement("stop", { offset: 1, stopColor: "#2f57ff" }))),
        React.createElement("g", { id: "Group_48192", "data-name": "Group 48192", transform: "translate(14651 11404)" },
            React.createElement("g", { id: "Group_48191", "data-name": "Group 48191", transform: "translate(-525 198)" },
                React.createElement("g", { id: "Group_48186", "data-name": "Group 48186", transform: "translate(66 5)" },
                    React.createElement("rect", { id: "Rectangle_25783", "data-name": "Rectangle 25783", width: 30, height: 30, transform: "translate(-14192 -11607)", fill: "none" }))),
            React.createElement("path", { id: "Path_63394", "data-name": "Path 63394", d: "M23,6.813,21.187,5,14,12.187,6.813,5,5,6.813,12.187,14,5,21.187,6.813,23,14,15.813,21.187,23,23,21.187,15.813,14Z", transform: "translate(-14650 -11403)", fill: "url(#linear-gradient)" }))));
}
exports.Close = Close;
//# sourceMappingURL=Close.js.map